<template>
  <!--<span class="social-links">-->
    <!--<a :class="['btn-social', buttonClass, socialClass(m.text)]"-->
       <!--:href="m.link"-->
       <!--target="_blank"-->
       <!--v-for="(m, k) in social" :key="k">{{m.text}}</a>-->
  <!--</span>-->

  <span class="socials">
<!--     <a class="social-icons ins" href="#" title="instagram"></a>-->
<!--     <a class="social-icons fa" href="#" title="facebook"></a>-->
   <a   :href="m.link"
        target="_blank"
        v-for="(m, k) in social" :key="k">
       <i class="fa" :class="['fa', buttonClass, socialClass(m.name)]" ></i>
     </a>
     <!--<a href="#" title="facebook"><i class="fa fa-facebook sq"></i></a>-->
     <!--<a href="#" title="instagram"><i class="fa fa-instagram"></i></a>-->
  </span>
</template>

<script>
  export default {
    props: ['buttonClass'],
    computed: { 
      social() {
          console.log(this.$store.state.menu.menuItems.social.item);
        return this.$store.state.menu.menuItems.social.items;
      },
    },
    methods: {
      socialClass(socialName) {
        switch (socialName) {
          case 'Facebook':
            return 'fa-facebook sq';
          case 'YouTube':
            return 'fa-youtube';
          case 'Instagram':
            return 'fa-instagram';
          case 'Vk':
              return 'fa-vk';
          case 'Telegam':
              return 'fa-telegram';
        }
        return '';
      },
    },
    mounted() {
      this.$store.dispatch('menu/loadMenu', 'social');
    },
  }
</script>

<style lang="scss" scoped>
    .socials {
        a {
            color: $color-white;
            margin-right: 10px;
            vertical-align: middle;

            &:last-child {
                margin-right: 0px;
            }
            .fa {
                @include ease();
                color: $color-white;
                font-size: 1.8rem;
                &.fa-youtube {
                  font-size: 1.6rem;
                }
                &.sq {
                    border:2px solid $color-white;
                    font-size: 1rem;
                    padding: 4px 2px 0 8px;
                    border-radius: 4px;
                }
                &:hover {
                    opacity: 0.6;
                }
            }
        }
    }


</style>



// WEBPACK FOOTER //
// components/shared/SocialLinks.vue